const AI_CHAT_SESSION_PREFIX = 'ai-chat-session:'
const AI_CHAT_HISTORY_KEY = 'ai-chat-history'
const AI_CHAT_LAST_ACTIVE_HISTORY_KEY = 'ai-chat-last-active-history-by-context'
const AI_CHAT_COMPONENT_CONTEXT_PREFIX = 'ai-chat-component-context:'

const DEFAULT_MAX_ACTIVE_CHAT_SESSIONS = 5

function getStorageKeys(storage: Storage): string[] {
  return Array.from({ length: storage.length }, (_, index) => storage.key(index)).filter((key): key is string =>
    Boolean(key)
  )
}

function getSessionLastUpdatedAt(storage: Storage, key: string): number {
  try {
    const session = JSON.parse(storage.getItem(key) ?? '{}') as { lastUpdatedAt?: unknown; createdAt?: unknown }
    if (typeof session.lastUpdatedAt === 'number') return session.lastUpdatedAt
    if (typeof session.createdAt === 'number') return session.createdAt
  } catch {
    return 0
  }

  return 0
}

export function pruneAiChatSessionStorage({
  keepChatId,
  maxSessions = DEFAULT_MAX_ACTIVE_CHAT_SESSIONS,
}: {
  keepChatId?: string
  maxSessions?: number
} = {}) {
  if (typeof window === 'undefined') return

  const keepKey = keepChatId ? `${AI_CHAT_SESSION_PREFIX}${keepChatId}` : undefined
  const sessionKeys = getStorageKeys(window.localStorage)
    .filter((key) => key.startsWith(AI_CHAT_SESSION_PREFIX))
    .sort((firstKey, secondKey) => {
      if (firstKey === keepKey) return -1
      if (secondKey === keepKey) return 1
      return getSessionLastUpdatedAt(window.localStorage, secondKey) - getSessionLastUpdatedAt(window.localStorage, firstKey)
    })

  sessionKeys.slice(maxSessions).forEach((key) => window.localStorage.removeItem(key))
}

export function clearAiChatBrowserStorage() {
  if (typeof window === 'undefined') return

  getStorageKeys(window.localStorage).forEach((key) => {
    if (
      key.startsWith(AI_CHAT_SESSION_PREFIX) ||
      key === AI_CHAT_HISTORY_KEY ||
      key === AI_CHAT_LAST_ACTIVE_HISTORY_KEY
    ) {
      window.localStorage.removeItem(key)
    }
  })

  getStorageKeys(window.sessionStorage).forEach((key) => {
    if (key.startsWith(AI_CHAT_COMPONENT_CONTEXT_PREFIX)) {
      window.sessionStorage.removeItem(key)
    }
  })
}
